export default {
  install: (app) => {
    const states = {
      PENDING: "pending",
      IN_THE_WORKS: "in-the-works",
      NEGATIVE_FEEDBACK: "negative-feedback",
      COMPLETED: "completed",
      ON_HOLD: "on-hold",
      ASSIGNED: "assigned",
      SITU: "situ",
      ISO_CUSTOM: "iso-custom",
      ISO_FAILED: "iso-failed",
      ISO_IN_CHANGED_TEST: "iso-in-changed-test",
      ISO_IN_CHANGED_DATE: "iso-in-changed-date",
      ISO_IN_SKIPPED: "iso-in-skipped",
      ISO_REASSIGNED: "iso-reassigned",
      ISO_IN_CHOOSE_FORK: "iso-in-choose-fork",
      ISO_CHANGED_DEFAULT_FLOW: "iso-changed-default-flow",
      BAGGED: "bagged",
      PACKAGED: "packaged",
      SHIPPED: "shipped",
      SENT_TO_EXTERNAL: "sent-to-external",
      MANAGER_FAILED: "manager-failed",
      MANAGER_CHANGED_TEST: "manager-changed-test",
      MANAGER_REASSIGNED: "manager-reassigned",
      MANAGER_SKIPPED: "manager-skipped",
      CLINIC_PRINTED: "clinic-printed",
      MANAGER_CHANGED_DATE: "manager-changed-date",
      MISSING_DOWNLOAD: "missing-download",
    };

    const localStates = {
        RESUME: "resume",
        RESUME_FAILED: "resume-failed",
        CHANGE_TECHNICIAN: "change-technician",
        ISO_CUSTOM: "iso-custom",
        MANAGER_CUSTOM: "manager-custom",
    };

    const prescriptionTestStates = {
        DA_INVIARE: "da-inviare",
        INVIATA_AL_LAB: "inviata-al-lab",
        IN_LAVORAZIONE: "in-lavorazione",
        FALLITA: "fallita",
        SALTATA: "saltata",
        COMPLETATA: "completata",
        REJECTED: "rejected",
        FAILED_LAB: "failed-lab",
        SUSPENDED_LAB: "suspended-lab",
        CHANGED_TEST_LAB: "changed-test-lab",
        WITH_DATE: "with-date",
    };

    const testWorkQueueTypes = {
        ISO_SKIPPED: "iso-skipped",
        REMOTE_PRINTING: "remote-printing",
        AUTOMATIC_DESIGN: "automatic-design",
        EXTERNAL_OF_PRIMOUP: "external-of-primoup",
        UNCHANGED: "unchanged",
        CRITICAL_REQUESTER: "critical-requester",
    };

    const departments = {
        ISO_MOBILE: "iso-mobile",
        ISO_FISSA: "iso-fissa",
        ISO_PROGETTAZIONE: "iso-progettazione",
        ISO_PREPARAZIONE: "iso-preparazione",
        ISO_QUALITA: "iso-qualita",
        MOBILE: "mobile",
        SCANSIONE: "scansione",
        FINITURA: "finitura",
        PREPARAZIONE: "preparazione",
        CAM: "cam",
        PROGETTAZIONE: "progettazione",
        AMMINISTRAZIONE: "amministrazione",
        LOGISTICS: "logistica",
      };

      const internalPhases=  {
        FRESAGGIO: 'fresaggio'
      };

      const userStates = {
        AVAILABLE: 'available',
        WORKING: 'working',
      };

      const roles = {
        TECHNICIAN: 'technician',
        VENDOR: 'vendor',
        MANAGER: 'manager',
      };

      const materials = {
        CERA: "cera",
        CERAMICA: "ceramica",
        COMPOSITO: "composito",
        DCL_REINFORCED_RESIN: "resina-rinforzata-dcl",
        DISILICATE: "disilicato",
        ENAMIC: "enamic",
        GESSO: "gesso",
        GIG_SNODATO: "snodato",
        LEGA_PREZIOSA: "lega-preziosa",
        METALLO: "metallo",
        METALLO_BARRE: "metallo-barre",
        METALLO_CERAMICA: "metallo-ceramica",
        METALLO_COMPOSITO: "metallo-composito",
        METALLO_ZIRCONIA: "metallo-zirconia",
        NYLON: "nylon",
        PLASTIC: "plastica",
        PRE_ESTRATTIVA: "pre-estrattiva",
        RESIN: "resina",
        PRINTED_RESIN : "resina-stampata",
        RESINA_STAMPATA_MOBILE: "resina-stam",
        ZIRCONIA: "zirconia",
        ZIRCONIA_CERAMICA: "zirconia-ceramica",
        ZIRCONIA_CERAMICA_SU_IMPIANTO: "zirconia-ceramica-su-impianto",
        ZIRCONIA_SU_IMPIANTO: "zirconia-su-impianto",
        GRANDIO: "grandio",
      };

      const assetsType = {
        LOWER_ARCH: "lower-arch",
        UPPER_ARCH: "upper-arch",
        GUM: "gum",
        STUMP: "stump",
        MILLING: "milling",
        CUSTOM_PIN: "custom-pin",
        GIG: "gig",
        BASE_ARCH: "base-arch",
        BRACKET: "bracket",
        BAR: "bar",
      };

      const devicesType = {
        ANALOG_LABEL: 'analog-label',
        DIGITAL_LABEL: 'digital-label',
        PRINTER: 'printer',
        CHECKOUT: 'checkout',
      };

      const tagColors = {
        MAGENTA: "magenta",
        BLUE: "blue",
        GREEN: "green",
        CYAN: "cyan",
        RED: "red",
        YELLOW: "yellow",
        WHITE: "white",
      };

      const shippingProviders = {
        LOCAL: "locale",
        FEDEX: "fedex",
        DHL: "dhl",
        LOMBARDIA: "lombardia",
        TURIN_SOUTH: "torino-sud",
      };

      const remoteClinicIds = {
        SELARGIUS_ID: "218",
      };

      const digitalLabelTypes = {
        HIDDEN: "hidden",
        POSITION: "position",
        APPROXIMATE: "approximate",
        PROXIMITY: "proximity",
        PRESENCE: "presence",
        NO_DATA: "noData",
      };

      const digitalLabelTypeLabels = {
        hidden: "Nascosto",
        position: "Posizione",
        approximate: "Approssimato",
        proximity: "Prossimità",
        presence: "Presenza",
        noData: "Nessun dato"
      };

      const digitalLabelTypeStatus = {
        hidden: "warning",
        position: "success",
        approximate: "info",
        proximity: "warning",
        presence: "warning",
        noData: "error"
      };

      const digitalLabelTypeDescriptions = {
        hidden: "Il tag è rilevato ma è in un'area riservata",
        position: "Il tag è rilevato e triangolato correttamente",
        approximate: "Il tag è rilevato ma la posizione è fuori dall'area di tracciamento ideale",
        proximity: "Non riesce a capire la posizione precisa, ma può ricevere comandi",
        presence: "Non riesce a capire la posizione e nessuna antenna è vicina, ma può ricevere comandi",
        noData: "Il tag non viene rilevato e non può ricevere comandi"
      };

      const listCategories = {
        FISSA: 'protesi-fissa',
        MOBILE: 'protesi-mobile',
      };

      const moldingMaterials = [
        materials.CERA,
        materials.CERAMICA,
        materials.GIG_SNODATO,
        materials.NYLON,
        materials.PLASTIC,
        materials.PRE_ESTRATTIVA,
        materials.PRINTED_RESIN,
        materials.RESINA_STAMPATA_MOBILE,
      ];

      const millingMaterials = [
        materials.RESIN,
        materials.COMPOSITO,
        materials.DCL_REINFORCED_RESIN,
        materials.DISILICATE,
        materials.ENAMIC,
        materials.GESSO,
        materials.LEGA_PREZIOSA,
        materials.METALLO,
        materials.METALLO_BARRE,
        materials.METALLO_CERAMICA,
        materials.METALLO_COMPOSITO,
        materials.METALLO_ZIRCONIA,
        materials.ZIRCONIA,
        materials.ZIRCONIA_CERAMICA,
        materials.ZIRCONIA_CERAMICA_SU_IMPIANTO,
        materials.ZIRCONIA_SU_IMPIANTO,
        materials.GRANDIO,
      ];

      const nonDeliveryMillingMaterials = [
        materials.PLASTIC,
        materials.ZIRCONIA,
        materials.GRANDIO,
        materials.METALLO,
        materials.RESIN,
      ];

      const prescriptionTestNames = {
        DELIVERY: 'consegna',
      };

      // Configs.
      const modelConfigs = {
        stump:      { name: 'Moncone',          application: 'Moncone',       icon: 'stump/stump',           assetType: assetsType.STUMP,           material: materials.PRINTED_RESIN },
        customPin:  { name: 'Perno Custom',     application: 'Perno Custom',  icon: 'custom-pin/custom-pin', assetType: assetsType.CUSTOM_PIN,      material: materials.METALLO },
        gum:        { name: 'Gengiva',          application: 'Gengiva',       icon: 'gum/gum',               assetType: assetsType.GUM,             material: materials.PRINTED_RESIN },
        gig:        { name: 'Gig',              application: 'Gig',           icon: 'gig/gig',               assetType: assetsType.GIG,             material: materials.PRINTED_RESIN },
        bar:        { name: 'Barra',            application: 'Barra',         icon: 'bar/bar',               assetType: assetsType.BAR,             material: materials.METALLO_BARRE },
        bracket:    { name: 'Barretta',         application: 'Barretta',      icon: 'bracket/bracket',       assetType: assetsType.BRACKET,         material: materials.RESINA_STAMPATA_MOBILE },
        baseArch:   { name: 'Base vallo',       application: 'Base vallo',    icon: 'arch/base-arch',        assetType: assetsType.BASE_ARCH,       material: materials.PRINTED_RESIN },
        upperArch:  { name: 'A. superiore',     application: 'Arcata',        icon: 'arch/arch-sup',         assetType: assetsType.UPPER_ARCH,      material: materials.PRINTED_RESIN,         slug: assetsType.UPPER_ARCH,   zone_number: 'sup' },
        lowerArch:  { name: 'A. inferiore',     application: 'Arcata',        icon: 'arch/arch-inf',         assetType: assetsType.LOWER_ARCH,      material: materials.PRINTED_RESIN,         slug: assetsType.LOWER_ARCH,   zone_number: 'inf',},
      };

      const constants = {
        states,
        localStates,
        prescriptionTestStates,
        testWorkQueueTypes,
        departments,
        internalPhases,
        userStates,
        roles,
        materials,
        assetsType,
        devicesType,
        tagColors,
        shippingProviders,
        remoteClinicIds,
        digitalLabelTypes,
        digitalLabelTypeLabels,
        digitalLabelTypeStatus,
        digitalLabelTypeDescriptions,
        modelConfigs,
        moldingMaterials,
        millingMaterials,
        nonDeliveryMillingMaterials,
        prescriptionTestNames,
        listCategories,
      };

    app.provide('constants', constants);
  },
};
